<template>
    <qweForm
        :operation="operation"
        :contentType="contentType"
        :contentItemId = "contentItemId"
        :flowCurrentNodeId="nodeId"
        @[formEvent.initForm] = "initForm"
        @[formEvent.submit] = "submitForm">
    </qweForm>
</template>

<script>
    import qweForm from "../../components/Form/FormItem.vue"
    import form from "./Form"

    export default {
        name:"Form",
        mixins:[form],

        components:{
            "qweForm":qweForm
        }
    }
</script>